

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Custom styles for the SidenavCollapse
import {
    collapseItem,
    collapseIconBox,
    collapseIcon,
    collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";

// Material Dashboard 2 React context

import { useSelector } from "react-redux";
import {memo, useEffect, useState} from "react";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {Collapse, Tooltip} from "@mui/material";
import List from "@mui/material/List";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {noop} from "lodash";
import {useTranslation} from "react-i18next";

function SidenavCollapse({ icon, name, active,child,rootRoute,root,setTabLoading,...rest }) {
    const {t} = useTranslation()
    const transparentSidenav = useSelector(state => state?.common?.transparentSidenav,(prev, next) => prev === next)
    const miniSidenav = useSelector(state => state?.common?.miniSidenav,(prev, next) => prev === next)
    const whiteSidenav = useSelector(state => state?.common?.whiteSidenav,(prev, next) => prev === next)
    const sidenavColor = useSelector(state => state?.common?.sidenavColor,(prev, next) => prev === next)
    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const [open,setOpen] = useState(false)
    const { pathname } = useLocation();
    const collapseName = location.pathname.split("/")[location.pathname.split("/").length -1];

    const nav = useNavigate()
    useEffect(() => {

        const newPath = pathname.slice(4);
        const parts = newPath.split('/');

        const part = '/'+ parts[1]

        if(rootRoute && part !== rootRoute){
            setOpen(false)
        } else if(rootRoute && part === rootRoute) {
            setOpen(true)
        }

    }, [pathname]);



    const handleClick = (event) => {
        if (!child) {
            const targetPath = rootRoute?.startsWith('/app') ? `${rootRoute}${rest.to || ''}` : `/app${rootRoute}${rest.to || ''}`;

            if (pathname !== targetPath) {
                setTabLoading(true); // 设置加载状态
                nav(targetPath); // 路由跳转
            }// 例如设置加载状态// 或者执行路由跳转等其他逻辑
        }
        if(rootRoute){
            setOpen(!open);
        }


    };

    const listItemContent = (<ListItem component="li" sx={{display:'flex',flexDirection:'column'}} >
        <MDBox
            onClick={handleClick}
            {...rest}
            style={root?{}:{paddingLeft:'10%'}}
            sx={(theme) =>
                collapseItem(theme, {
                    active,
                    transparentSidenav,
                    whiteSidenav,
                    darkMode,
                    sidenavColor,
                })
            }

        >
            <ListItemIcon
                sx={(theme) =>
                    collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode, active })
                }
            >
                {typeof icon === "string" ? (
                    <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
                ) : (
                    icon
                )}
            </ListItemIcon>

            <ListItemText
                primary={t(`Sidebar.${name}`)}
                sx={(theme) =>
                    collapseText(theme, {
                        miniSidenav,
                        transparentSidenav,
                        whiteSidenav,
                        active,
                    })
                }
            />
            {child && (open ? <ExpandLess /> : <ExpandMore />)}
        </MDBox>
        {child &&
            <MDBox
                sx={{
                    width:'100%',
                    boxShadow: '-12px -8px 40px 0px rgba(70,70,70,0.12) inset',
                }}
            >
                <Collapse in={open} timeout="auto" mountOnEnter unmountOnExit>
                    <List component="div" disablePadding>
                        {child.map(v => {

                            return (
                                <NavLink
                                    onClick={() => {
                                        if (pathname !== rootRoute?.startsWith('/app') ? `${rootRoute}${v.route}` : `/app${rootRoute}${v.route}`) {
                                            let path = rootRoute?.startsWith('/app') ? `${rootRoute}${v.route}` : `/app${rootRoute}${v.route}`
                                            // setTabLoading(true); // 只有当目标路径和当前路径不一致时，才设置 setTabLoading
                                        }
                                    }}
                                    key={v.key}
                                    to={rootRoute?.startsWith('/app') ? `${rootRoute}${v.route}` : `/app${rootRoute}${v.route}`}>

                                    <SidenavCollapse
                                        name={v.name}
                                        icon={v.icon}
                                        active={v.key === collapseName}
                                        child={v.children} // 传递子项
                                        rootRoute={rootRoute + v.route}
                                        root={false}
                                        setTabLoading = {setTabLoading}
                                    />
                                </NavLink>
                            );
                        })}
                    </List>
                </Collapse>
            </MDBox>
        }

    </ListItem>)


    return ((miniSidenav && !child) || (miniSidenav && child && !open)) ? (
        <Tooltip title={name} arrow placement="right">
            {listItemContent}
        </Tooltip>
    ) : (
        listItemContent
    );
}

// Setting default values for the props of SidenavCollapse
SidenavCollapse.defaultProps = {
    active: false,
    root:true
};

// Typechecking props for the SidenavCollapse
SidenavCollapse.propTypes = {
    icon: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    active: PropTypes.bool,
    child:PropTypes.array,
    rootRoute:PropTypes.string,
    root:PropTypes.bool
};

export default memo(SidenavCollapse);
